module.exports = __webpack_public_path__ + "img/HalimYusuf-GavaKu.34709f59.jpg";